import { render, staticRenderFns } from "./DialoguePersistent.vue?vue&type=template&id=f5ef545c&scoped=true&"
import script from "./DialoguePersistent.vue?vue&type=script&lang=js&"
export * from "./DialoguePersistent.vue?vue&type=script&lang=js&"
import style0 from "./DialoguePersistent.vue?vue&type=style&index=0&id=f5ef545c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ef545c",
  null
  
)

export default component.exports